export default [
    {
      path: '/landing/products',
      name: 'products',
      component: () => import('@/views/landing/Products.vue'),
    },
  ]